/* @flow weak */
import Link from 'components/Link.jsx';
import Glyph from 'components/Glyph.jsx';
import React from 'react';
import Text from 'components/Text.jsx';

import cx from 'classnames';

import styles from './styles/AppLayoutContentViewHeader.css';

export default class AppLayoutContentViewHeader extends React.Component {
  static propTypes = {
    title: React.PropTypes.node.isRequired,
    renderPreviousButton: React.PropTypes.bool,
    onRequestPrevious: React.PropTypes.func,
  };

  renderTitleWithPreviousButton(title) {
    return (
      <Link
        color="pitch"
        className={styles.previousButton}
        onClick={this.props.onRequestPrevious}>
        <Glyph name="arrow-left" color="brand" size="large" />
        {title}
      </Link>
    );
  }

  render() {
    const { title, children, className } = this.props;
    return (
      <div className={cx(styles.this, className)}>
        <Text className={styles.title} size="medium" truncate>
          {
            this.props.renderPreviousButton ?
              this.renderTitleWithPreviousButton(title) :
              title
          }
        </Text>
        {
          children &&
            <div className={styles.children}>
              {children}
            </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/AppLayoutContentViewHeader.jsx